import React, { useEffect } from "react";
import { Form, Input, Button, Select, message } from "antd";
import {
  createSubscriptionAudience,
  updateSubscriptionAudience,
} from "../../api/subscription_audiences/subscriptionAudiencesRequest";

const { Option } = Select;

const SubscriptionAudienceForm = ({ audience, subscriptionTypes, onSuccess, onCancel }) => {
  const [form] = Form.useForm();

  useEffect(() => {
    if (audience) {
      form.setFieldsValue(audience);
    } else {
      form.resetFields();
    }
  }, [audience, form]);

  const handleFinish = async (values) => {
    try {
      if (audience && audience.id) {
        await updateSubscriptionAudience(audience.id, values);
        message.success("Audience modifiée");
      } else {
        await createSubscriptionAudience(values);
        message.success("Audience créée");
      }
      onSuccess();
    } catch (error) {
      message.error("Erreur lors de l'enregistrement");
    }
  };

  return (
    <Form
      form={form}
      layout="vertical"
      onFinish={handleFinish}
      initialValues={audience || {}}
    >
      <Form.Item
        name="name"
        label="Nom"
        rules={[{ required: true, message: "Le nom est requis" }]}
      >
        <Input placeholder="Nom de l'audience" />
      </Form.Item>
      <Form.Item name="description" label="Description">
        <Input.TextArea placeholder="Description" rows={3} />
      </Form.Item>
      <Form.Item
        name="subscription_type_id"
        label="Type d'abonnement"
        rules={[{ required: true, message: "Le type d'abonnement est requis" }]}
      >
        <Select placeholder="Sélectionner un type d'abonnement">
          {subscriptionTypes.map((type) => (
            <Option key={type.id} value={type.id}>
              {type.name}
            </Option>
          ))}
        </Select>
      </Form.Item>
      <div style={{ display: "flex", justifyContent: "flex-end", gap: 8 }}>
        <Button onClick={onCancel}>Annuler</Button>
        <Button type="primary" htmlType="submit">
          {audience ? "Enregistrer" : "Créer"}
        </Button>
      </div>
    </Form>
  );
};

export default SubscriptionAudienceForm;
